{
  "Accessibility Menu": "Menu d'accessibilité",
  "Reset settings": "Réinitialiser les paramètres",
  "Close": "Fermer",
  "Content Adjustments": "Ajustements de contenu",
  "Adjust Font Size": "Ajuster la taille de police",
  "Highlight Title": "Surligner le titre",
  "Highlight Links": "Surligner les liens",
  "Readable Font": "Police lisible",
  "Color Adjustments": "Ajustements de couleur",
  "Dark Contrast": "Contraste foncé",
  "Light Contrast": "Contraste clair",
  "High Contrast": "Contraste élevé",
  "High Saturation": "Saturation élevée",
  "Low Saturation": "Saturation faible",
  "Monochrome": "Monochrome",
  "Contrast": "Contraste",
  "Invert Colors": "Inverser les couleurs",
  "Tools": "Outils",
  "Reading Guide": "Guide de lecture",
  "Stop Animations": "Arrêter les animations",
  "Big Cursor": "Gros curseur",
  "Increase Font Size": "Augmenter la taille de police",
  "Decrease Font Size": "Réduire la taille de police",
  "Letter Spacing": "Espacement des lettres",
  "Line Height": "Hauteur de ligne",
  "Font Weight": "Poids de la police",
  "Dyslexia Font": "Police dyslexie",
  "Language": "Langue",
  "Open Accessibility Menu": "Ouvrir le menu d'accessibilité",
  "Widget Settings": "Paramètres du widget",
  "Widget Position": "Position du widget",
  "Top Left": "Haut gauche",
  "Top Center": "Haut centre",
  "Top Right": "Haut droite",
  "Center Left": "Centre gauche",
  "Center Right": "Centre droite",
  "Bottom Left": "Bas gauche",
  "Bottom Center": "Bas centre",
  "Bottom Right": "Bas droite",
  "Screen Reader": "Lecteur d’écran",
  "Voice Navigation": "Navigation vocale",
  "Custom Color": "Couleur personnalisée",
  "Change the site's colors": "Modifier les couleurs du site",
  "Backgrounds": "Arrière-plans",
  "Headings": "Titres",
  "Contents": "Contenus",
  "Reset colors": "Réinitialiser les couleurs",
  "Image Desaturation": "Désaturation de l’image",
  "Search languages": "Rechercher des langues",
  "No languages found": "Aucune langue trouvée",
  "Accessibility Profiles": "Profils d'accessibilité",
  "Motor Impaired": "Handicap moteur",
  "Big cursor, voice navigation, and no animations.": "Grand curseur, navigation vocale et aucune animation.",
  "Blind": "Cécité",
  "Screen reader helpers with higher contrast.": "Aides lecteur d'écran avec contraste renforcé.",
  "Color Blind": "Daltonisme",
  "High contrast palette with desaturated media.": "Palette à fort contraste avec médias désaturés.",
  "Dyslexia": "Dyslexie",
  "Friendly font, extra spacing, stronger weight.": "Police adaptée, espacement accru et graisse renforcée.",
  "Low vision": "Basse vision",
  "Dark contrast and 130% magnification.": "Contraste sombre et agrandissement de 130 %.",
  "Cognitive & Learning": "Cognitif & apprentissage",
  "Highlights key sections and enables voice help.": "Met en évidence les sections clés et active l'aide vocale.",
  "Seizure & Epileptic": "Crises et épilepsie",
  "Stops animations and desaturates imagery.": "Arrête les animations et désature les visuels.",
  "ADHD": "TDAH",
  "Reading guide, highlighted links, calmer palette.": "Guide de lecture, liens surlignés et palette apaisée.",
  "Widget Size": "Taille du widget",
  "Default": "Défaut",
  "Medium": "Moyen",
  "Small": "Petit",
  "Color Blindness": "Daltonisme",
  "Protanopia": "Protanopie",
  "Deuteranopia": "Deutéranopie",
  "Tritanopia": "Tritanopie",
  "Achromatopsia": "Achromatopsie",
  "Simulates and assists users with color vision deficiencies.": "Simule et aide les utilisateurs ayant des déficiences de la vision des couleurs."
}
